import store from "src/store/index";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import routes from "./routes";

if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
}
// configure router
const router = new VueRouter({
    mode: "history",
    routes,
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            const position = savedPosition || {};
            if (!savedPosition) {
                if (to.hash) {
                    position.selector = to.hash;
                }
                if (to.matched.some((m) => m.meta.scrollToTop)) {
                    position.x = 0;
                    position.y = 0;
                }
            }
            router.app.$root.$once("triggerScroll", () => {
                router.app.$nextTick(() => {
                    // there is a race condition if the scroll position
                    // is reliant upon data that loads on the page
                    // if the data takes longer to load than when this fires,
                    // the scroll will not work properly
                    setTimeout(() => {
                        resolve(position);
                        store.commit("updatePerfectScroll");
                    }, 50);
                });
            });
        });
    },
});

router.beforeEach(async (to, from, next) => beforeEach(to, from, next, store));

export default router;
